import { useForm } from "react-hook-form"
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useContext } from "react";

import PlaceAutocomplete from "./PlaceAutocomplete/PlaceAutocomplete";
import Spinner from '../../Spinner/Spinner';
import TotalFares from "./TotalFares/TotalFares";
import getRideType from "../../../utils/getRideType";
import classes from './BookingForm.module.css';
import CalculationMessage from "./calculationMessage/CalculationMessage";
import BookignMessage from "../BookingMessage/BookingMessage";
import * as actions from '../../../store/actions';
import LocationContext from "../../../locationContext";

const BookignForm = (props) => {
    const location = useContext(LocationContext);
    const { t } = useTranslation();

    const {
        register,
        handleSubmit,
        formState: { errors },
        getValues,
        setValue,
    } = useForm();

    const isSamePlaces = () => {
        return location.pickupPlace.geometry.location.lat() === location.dropOffPlace.geometry.location.lat()
            && location.pickupPlace.geometry.location.lng() === location.dropOffPlace.geometry.location.lng();
    }

    const onSubmit = (data) => {
        if (!location.pickupPlace || !location.dropOffPlace) {

            props.setBookErrors([
                'Please choose correct locations',
            ]);
            return;
        }

        if (isSamePlaces()) {

            props.setBookErrors([
                'Please different places',
            ]);
            return;
        }

        const bookignData = {
            dropOfAddress: location.dropOffPlace.formatted_address,
            dropOf: {
                latitude: location.dropOffPlace.geometry.location.lat(),
                longitude: location.dropOffPlace.geometry.location.lng(),
            },
            pickUpAddress: location.pickupPlace.formatted_address,
            pickUp: {
                latitude: location.pickupPlace.geometry.location.lat(),
                longitude: location.pickupPlace.geometry.location.lng(),
            },
            riderName: data.riderName,
            riderPhone: data.riderPhone,
            schedule: {
                date: data.date,
            },
            rideType: data.rideType,
            countryCode: location.countryCode,
        };
        props.book(bookignData);
    }

    const calculateFare = (rideType) => {
        const calcRideType = getRideType(rideType);
        props.getFare(calcRideType, location.country);
    }

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <div className={classes.FormFields}>
                <PlaceAutocomplete
                    label={t('booking.form.sourceLabel')}
                    placeholder={t('booking.form.sourcePlaceholder')}
                    id="source"
                    name="pickUpAddress"
                    errors={errors}
                    register={register}
                    setValue={setValue} />
                <PlaceAutocomplete
                    label={t('booking.form.destinationLabel')}
                    placeholder={t('booking.form.destinationPlaceholder')}
                    id="destination"
                    name="dropOfAddress"
                    errors={errors}
                    register={register}
                    setValue={setValue} />
                <div className={classes.RiderDetails}>
                    <div className={classes.RiderName}>
                        <div className="form-group">
                            <label htmlFor="riderName">{t('booking.form.riderNameLabel')}</label>
                            <input
                                id="riderName"
                                type="text"
                                placeholder={t('booking.form.riderNamePlaceholder')}
                                className={errors && errors.riderName ? 'invalid' : ''}
                                {...register('riderName', { required: true })} />
                        </div>
                    </div>
                    <div className={classes.RiderPhoneNumber}>
                        <div className="form-group">
                            <label htmlFor="riderPhone">{t('booking.form.phoneNumberLabel')}</label>
                            <input
                                id="riderPhone"
                                type="text"
                                placeholder={t('booking.form.phoneNumberPlaceholder')}
                                className={errors && errors.riderPhone ? 'invalid' : ''}
                                {...register('riderPhone', { required: true })} />
                        </div>
                    </div>
                </div>
                <div className={classes.RiderDetails}>
                    <div className={classes.RideType}>
                        <div className="form-group">
                            <label htmlFor="rideType">{t('booking.form.rideTypeLabel')}</label>
                            <select
                                id="rideType"
                                className={errors && errors.rideType ? 'invalid' : ''}
                                {...register('rideType', { required: true })}
                            >
                                <option value="car-save">Red Save</option>
                                <option value="car-go">Red Go</option>
                                <option value="car-x">Red X</option>
                            </select>
                        </div>
                    </div>
                    <div className={classes.DateAndTime}>
                        <div className="form-group">
                            <label htmlFor="date">{t('booking.form.dateLabel')}</label>
                            <input
                                type="datetime-local"
                                placeholder="Enter date and time"
                                className={errors && errors.date ? 'invalid' : ''}
                                {...register('date', { required: true })} />
                        </div>
                    </div>
                </div>
            </div>
            <BookignMessage error={props.error} booked={props.booked} />
            <CalculationMessage error={props.calculationError} />
            <TotalFares
                total={props.total}
                distanceText={props.distanceText}
                durationText={props.durationText} />
            <div className={classes.BookingActionButtons}>
                {
                    props.loading
                        ? <Spinner />
                        : <button
                            className="button primary-button"
                            type="submit">
                            {t('booking.form.bookNow')}
                        </button>
                }
                {
                    props.calculateLoading
                        ? <Spinner />
                        : <button
                            className="button outline-button"
                            type="button"
                            onClick={() => calculateFare(getValues("rideType"))}
                            disabled={!location.pickupPlace && !location.dropOffPlace}>
                            {t('booking.form.calculate')}
                        </button>
                }
            </div>
        </form>
    );
}

const mapStateToProps = (state) => {
    return {
        calculateLoading: state.fare.loading,
        calculationError: state.fare.error,
        fare: state.fare.fare,
        total: state.fare.totalPrice,
        distanceText: state.fare.distanceText,
        durationText: state.fare.durationText,
        loading: state.book.loading,
        error: state.book.error,
        booked: state.book.booked,
        //pickupPlace: state.locations.pickupLocation,
        //dropOffPlace: state.locations.dropoffLocation,
        //disabled: !state.locations.pickupLocation && !state.locations.dropoffLocation,
        //country: state.locations.country,
        //countryCode: state.locations.countryCode,
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        getFare: (rideType, country) => dispatch(actions.getFare(rideType, country)),
        book: (data) => dispatch(actions.book(data)),
        setBookErrors: (error) => dispatch(actions.bookFail(error)),
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BookignForm);